module.exports = __webpack_public_path__ + "static/media/mercedes-benz_logo.6aed3b6d.png";